.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.logo__container {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
}

@media screen and (min-width: 980px) {
  .logo__container {
    height: 32px;
    margin-bottom: 24px;
  }

  :host(:not([dir="rtl"])) .logo__container {
    float: left;
    margin-right: 12px;
  }

  :host([dir="rtl"]) .logo__container {
    float: right;
    margin-left: 12px;
  }
}

@media screen and (max-width: 979px) {
  .logo__container {
    margin-top: 10px;
    margin-bottom: 16px;
    max-height: -moz-fit-content;
    max-height: fit-content;
  }
}

.pes__logo {
  width: 32px;
  height: 32px;
}

@media screen and (max-width: 719px) {
  .pes__logo {
    width: 24px;
    height: 24px;
  }
}

.pes__title {
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  color: #3dcd58;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .pes__title {
    float: left;
  }

  :host([dir="rtl"]) .pes__title {
    float: right;
  }
}

@media screen and (max-width: 719px) {
  .pes__title {
    font-size: 16px;
    line-height: 20px;
  }
}